import {createSlice} from '@reduxjs/toolkit'

const initialState={
    email:null,
    username:null,
};

const userSlice = createSlice({
    name:'user',
    initialState,
    reducers:{
          setUserInfo: (state, action) => {
      state.email = action.payload.email;
      state.username = action.payload.username;
    },
    },
});

export const {setUserInfo} = userSlice.actions;
export default userSlice.reducer;